module.exports = __webpack_public_path__ + "static/media/connection_service_business_unit_1.30188dd4.png";